import { render, staticRenderFns } from "./ModalLogout.vue?vue&type=template&id=1bffc917&scoped=true"
import script from "./ModalLogout.vue?vue&type=script&lang=js"
export * from "./ModalLogout.vue?vue&type=script&lang=js"
import style0 from "./ModalLogout.vue?vue&type=style&index=0&id=1bffc917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bffc917",
  null
  
)

export default component.exports